<template>
  <div>

    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button-group class="float-right">
        <el-button type="info" size="small" class="YeniBtn" @click="PersonelEkle">{{ Sayfa.ButtonAdi }}
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-table
        v-if="Liste"
        :data="Liste"
        :default-sort="{prop: 'Unvan', order: 'ascending'}"
        class="golgetable"
        @current-change="TableSecim"
        :height="Height">
        <el-table-column
          label="Ad Soyad"
          prop="Unvan">
        </el-table-column>
        <el-table-column
          label="TC Kimlik"
          prop="vNo"
          width="120">
        </el-table-column>
        <el-table-column
          label="SGK Sicil No"
          prop="SGK.SicilNo"
          width="150">
        </el-table-column>
        <el-table-column
          label="Telefon"
          prop="Telefon"
          width="120">
        </el-table-column>
        <el-table-column
          label="Giriş Tarihi"
          prop="pGirisText"
          width="120">
        </el-table-column>
        <el-table-column
          label="Maaş"
          prop="pMaas"
          width="120">
        </el-table-column>
        <el-table-column
          label="Kalan İzin"
          prop="kIzin"
          width="120">
        </el-table-column>
      </el-table>
      <div class="ekranbos" v-if="!Liste"></div>
    </div>
  </div>
</template>

<script>
import FormModal from "../../../components/Pack/Muhasebe/cari/FormModal";
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor, FormModal},
  data() {
    return {
      lo: false,
      Height: window.innerHeight - 150,
      Kelime: '',
      Yetki: false,
      ModalOlayi: false,
      Baslik: null,
      SeciliBina: null,
      Sayfa: {
        ButtonAdi: 'Personel Ekle',
        DuzenleAdi: this.$t('eGenel.10'),
        SilAdi: this.$t('eGenel.11'),
        Button: null,
        EkranAdi: 'Personel Detay',
        Adi: 'Personel Listesi',
        Menu: [],
        MenuDisplay: null,
      },
    }
  },
  methods: {
    PersonelEkle() {
      this.$alert('Personel ekleme/düzenleme ve silme işlemlerini Bina Bilgi Kartını Kullanınız', 'Personel Ekleme', {
        confirmButtonText: 'Anladım',
      });
    },
    TableSecim(val) {
      this.$router.push('/muhasebe/personel/' + val.id)
    },
    SayfaYukle() {
      this.ModalOlayi = false;
      if (this.$store.getters.BinaBilgi) {
        this.SeciliBina = this.$store.getters.BinaBilgi.id;
      }
      if (this.SeciliBina) {
        this.Getir();
      } else {
        this.$message.error("Bina Seçiniz");
      }
    },
    Getir() {
      this.ModalOlayi = false;
      this.lo = true;
      this.$store.dispatch("Get", {path: 'muhasebe/personel/liste/' + this.SeciliBina})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Liste = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.Yetki = this.$store.getters.Yetki.muhasebe == 2 ? true : false;
    },


  },
  mounted() {
    this.$store.commit("SayfaBilgi", this.Sayfa);
    this.SayfaYukle();

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Muhasebe/personel/Liste.vue